'use client'

import { X24 } from '@vinted/monochrome-icons'
import { Text, Button, Dialog, Navigation, Cell, Divider, Spacer, Card } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { viewSingleCheckoutEvent } from '@marketplace-web/checkout/checkout-data'

type Props = {
  checkoutId?: string
  isOpen: boolean
  onClose: () => void
}

const KlarnaPromoModal = ({ isOpen, checkoutId, onClose }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('checkout.payment.klarna.promo_info_modal')

  if (isOpen) {
    track(
      viewSingleCheckoutEvent({
        checkoutId: checkoutId || null,
        screen: 'klarna_education',
      }),
    )
  }

  return (
    <Dialog show={isOpen} testId="item-page-plugin-klarna-promo-modal">
      <Navigation
        body={translate('title')}
        right={
          <Button
            inline
            iconName={X24}
            theme="amplified"
            styling="flat"
            onClick={onClose}
            testId="item-page-plugin-klarna-promo-modal-navigation-close-button"
            aria-label={translate('a11y.actions.close')}
          />
        }
      />
      <Divider />
      <Cell styling="wide">
        <Text as="p" html text={translate('text')} />
        <Spacer size="x-large" />
        <Text as="p" type="subtitle" text={translate('option_title')} />
        <Spacer />
        <Card>
          <Cell>
            <Text as="p" bold theme="amplified" text={translate('option_pay_in_three_title')} />
            <Text as="p" text={translate('option_pay_in_three_text')} />
          </Cell>
          <Divider />
          <Cell>
            <Text as="p" bold theme="amplified" text={translate('option_pay_in_thirty_title')} />
            <Text as="p" text={translate('option_pay_in_thirty_text')} />
          </Cell>
          <Divider />
          <Cell>
            <Text as="p" bold theme="amplified" text={translate('option_pay_in_full_title')} />
            <Text as="p" text={translate('option_pay_in_full_text')} />
          </Cell>
        </Card>
        <Spacer />
        <Text as="p" type="subtitle" text={translate('option_description')} />
        <Spacer size="x-large" />
        <Text as="p" bold theme="amplified" text={translate('how_it_works_title')} />
        <Text as="p" text={translate('how_it_works_text')} />
      </Cell>
    </Dialog>
  )
}

export default KlarnaPromoModal
